import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.79952 13.6452C9.33104 13.1901 4.75381 8.38429 4.75381 8.38429C4.50276 8.13996 4.37724 7.81942 4.37724 7.50112C4.37724 7.18058 4.50276 6.86004 4.75381 6.61795C4.75381 6.61795 9.33104 1.81209 9.79952 1.35482C10.268 0.897547 11.1108 0.866166 11.6107 1.35482C12.1105 1.84124 12.1487 2.52266 11.6107 3.12115L7.41004 7.50112L11.6107 11.8811C12.1487 12.4796 12.1105 13.1588 11.6107 13.6452C11.1108 14.1338 10.268 14.1025 9.79952 13.6452Z",
		fill: "currentColor"
	})
});
export default SvgIconChevronLeft;
